import { Slide } from '@mui/material';
import React, { type FunctionComponent, type ReactNode } from 'react';
import FadeComponent from '../FadeComponent/FadeComponent';

export type SlideDirection = 'left' | 'right' | 'up' | 'down' | undefined;

interface ISlideComponentProps {
  slideDirection: SlideDirection;
  contentClassname?: string;
  children?: ReactNode;
}

const SlideComponent: FunctionComponent<ISlideComponentProps> = ({ children, slideDirection, contentClassname }) => {
  if (slideDirection) {
    return (
      <Slide in direction={slideDirection} timeout={500}>
        <div className={contentClassname ?? ''}>{children}</div>
      </Slide>
    );
  }

  return (
    <FadeComponent>
      <div>{children}</div>
    </FadeComponent>
  );
};

export default SlideComponent;
